/**
 * Per-app icon + icon-well colors (launcher tiles + header favorites).
 * Wells tuned for dark launcher panel; header uses iconColor only.
 */

const DEFAULT = {
  containerBg:
    'linear-gradient(160deg, rgba(148, 163, 184, 0.22) 0%, rgba(100, 116, 139, 0.12) 100%)',
  containerHover:
    'linear-gradient(160deg, rgba(148, 163, 184, 0.3) 0%, rgba(100, 116, 139, 0.18) 100%)',
  iconColor: '#cbd5e1',
};

export const TOOL_ICON_THEME = {
  'focus-lounge': {
    containerBg:
      'linear-gradient(160deg, rgba(13, 148, 136, 0.35) 0%, rgba(45, 212, 191, 0.18) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(13, 148, 136, 0.45) 0%, rgba(45, 212, 191, 0.26) 100%)',
    iconColor: '#2dd4bf',
  },
  'text-editor': {
    containerBg:
      'linear-gradient(160deg, rgba(59, 130, 246, 0.32) 0%, rgba(14, 165, 233, 0.18) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(59, 130, 246, 0.42) 0%, rgba(14, 165, 233, 0.26) 100%)',
    iconColor: '#60a5fa',
  },
  'qr-code': {
    containerBg:
      'linear-gradient(160deg, rgba(99, 102, 241, 0.32) 0%, rgba(129, 140, 248, 0.18) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(99, 102, 241, 0.42) 0%, rgba(129, 140, 248, 0.26) 100%)',
    iconColor: '#818cf8',
  },
  'app-icon-maker': {
    containerBg:
      'linear-gradient(160deg, rgba(139, 92, 246, 0.32) 0%, rgba(167, 139, 250, 0.18) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(139, 92, 246, 0.42) 0%, rgba(167, 139, 250, 0.26) 100%)',
    iconColor: '#c4b5fd',
  },
  'image-resizer': {
    containerBg:
      'linear-gradient(160deg, rgba(16, 185, 129, 0.32) 0%, rgba(45, 212, 191, 0.2) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(16, 185, 129, 0.42) 0%, rgba(45, 212, 191, 0.28) 100%)',
    iconColor: '#34d399',
  },
  'tic-tac-toe': {
    containerBg:
      'linear-gradient(160deg, rgba(20, 184, 166, 0.32) 0%, rgba(6, 182, 212, 0.18) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(20, 184, 166, 0.42) 0%, rgba(6, 182, 212, 0.26) 100%)',
    iconColor: '#5eead4',
  },
  'text-cleaner': {
    containerBg:
      'linear-gradient(160deg, rgba(45, 212, 191, 0.28) 0%, rgba(20, 184, 166, 0.16) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(45, 212, 191, 0.38) 0%, rgba(20, 184, 166, 0.24) 100%)',
    iconColor: '#5eead4',
  },
  calculator: {
    containerBg:
      'linear-gradient(160deg, rgba(13, 148, 136, 0.28) 0%, rgba(59, 130, 246, 0.16) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(13, 148, 136, 0.38) 0%, rgba(59, 130, 246, 0.24) 100%)',
    iconColor: '#2dd4bf',
  },
  'image-marker': {
    containerBg:
      'linear-gradient(160deg, rgba(99, 102, 241, 0.28) 0%, rgba(236, 72, 153, 0.14) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(99, 102, 241, 0.38) 0%, rgba(236, 72, 153, 0.22) 100%)',
    iconColor: '#a5b4fc',
  },
  'stream-player': {
    containerBg:
      'linear-gradient(160deg, rgba(15, 118, 110, 0.32) 0%, rgba(59, 130, 246, 0.2) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(15, 118, 110, 0.42) 0%, rgba(59, 130, 246, 0.28) 100%)',
    iconColor: '#5eead4',
  },
  'password-generator': {
    containerBg:
      'linear-gradient(160deg, rgba(15, 118, 110, 0.3) 0%, rgba(100, 116, 139, 0.16) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(15, 118, 110, 0.4) 0%, rgba(100, 116, 139, 0.22) 100%)',
    iconColor: '#5eead4',
  },
  'pdf-studio': {
    containerBg:
      'linear-gradient(160deg, rgba(220, 38, 38, 0.30) 0%, rgba(239, 68, 68, 0.16) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(220, 38, 38, 0.40) 0%, rgba(239, 68, 68, 0.24) 100%)',
    iconColor: '#fca5a5',
  },
  flowspace: {
    containerBg:
      'linear-gradient(160deg, rgba(2, 132, 199, 0.28) 0%, rgba(59, 130, 246, 0.14) 100%)',
    containerHover:
      'linear-gradient(160deg, rgba(2, 132, 199, 0.38) 0%, rgba(59, 130, 246, 0.22) 100%)',
    iconColor: '#7dd3fc',
  },
};

export function getToolIconTheme(appId) {
  return TOOL_ICON_THEME[appId] ?? DEFAULT;
}
